module.exports = __webpack_public_path__ + "static/img/logo.338f89e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo.png
// module id = TWqG
// module chunks = 10